(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["myko-recipe-article"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-myko-print]');
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const pictures = [...button.closest('.myko-article').querySelectorAll('img')];
      pictures.forEach((picture) => { picture.loading = 'eager'; });
      await Promise.race([
        Promise.allSettled(pictures.map((picture) => picture.decode())),
        new Promise((resolve) => setTimeout(resolve, 5000))
      ]);
      window.print();
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
